__turbopack_context__.v({
  "badge": "index-module-scss-module__RXG47W__badge",
});
